import { render, staticRenderFns } from "./index.vue?vue&type=template&id=627b233a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=627b233a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b233a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627b233a')) {
      api.createRecord('627b233a', component.options)
    } else {
      api.reload('627b233a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=627b233a&scoped=true", function () {
      api.rerender('627b233a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/mChatQrcode/index.vue"
export default component.exports